import { ajax } from '../index'

/**
 * 三方支付的相关 相关接口
 */
export default {
  // 获取Braintree支付token
  getBraintreeToken(orderId: number, dataObj: any) {
    return ajax.get('api', `/api/v1/payment/braintree/${orderId}`, dataObj)
  },

  // 校验braintree支付的结果
  braintreeCapture(orderId: number, dataObj: any) {
    return ajax.post('api', `/api/v1/payment/braintree/capture/${orderId}`, dataObj)
  },

  // 获取Adyen支付session
  getAdyenSession(orderId: number) {
    return ajax.get('api', `/api/v1/payment/adyen/${orderId}`, {})
  },

  // 获取Adyen支付配置信息
  getAdyenConfig(orderId: number) {
    return ajax.get('api', `/api/v1/payment/adyen/${orderId}`, {})
  },

  // 获取Adyen支付配置信息
  captureAdyen(orderId: number, dataObj: any) {
    return ajax.post('api', `/api/v1/payment/adyen/capture/${orderId}`, dataObj)
  },

  // 获取paypal支付的form表单数据
  getPaypalHostedForm(orderId: number) {
    return ajax.get('api', `/api/v1/payment/paypal/hosted-form/${orderId}`, {})
  },

  // 获取paypalFlow支付的form表单数据
  getPaypalFlowHostedForm(orderId: number) {
    return ajax.get('api', `/api/v1/payment/paypal-flow/form/${orderId}`, {})
  },

  // 获取paypal支付的跳转URL（类似zip支付的交互）
  getPaypalPaymentUrl(orderId: number) {
    return ajax.get('api', `/api/v1/payment/paypal/${orderId}`, {})
  },

  // 校验paypal 支付的结果
  paypalCapture(orderId: number, dataObj: any) {
    return ajax.post('api', `/api/v1/payment/paypal/capture/${orderId}`, dataObj)
  },

  // 获取zip支付的url
  zippayInit(orderId: number) {
    return ajax.get('api', `/api/v1/payment/zip-pay/${orderId}`, {})
  },

  // 校验zip-pay 支付的结果
  zippayCapture(orderId: number, dataObj: any) {
    return ajax.post('api', `/api/v1/payment/zip-pay/capture/${orderId}`, dataObj)
  },

  // 获取after-pay 支付的配置信息
  afterpayInit(orderId: number) {
    return ajax.get('api', `/api/v1/payment/after-pay/${orderId}`, {})
  },

  // 校验after-pay 支付的结果
  afterpayCapture(orderId: number, dataObj: any) {
    return ajax.post('api', `/api/v1/payment/after-pay/capture/${orderId}`, dataObj)
  },

  // 获取Afterpay 快捷支付 js
  getAfterPayExpressJs() {
    return ajax.get('api', `/api/v1/payment/after-pay/express-js`, {})
  },

  // 获取Afterpay 快捷支付 token
  getAfterPayExpressToken() {
    return ajax.get('api', `/api/v1/payment/after-pay/express`, {})
  },

  // 校验Afterpay 快捷支付的结果
  afterpayExpressCapture(dataObj: any) {
    return ajax.post('api', `/api/v1/payment/after-pay/express/capture`, dataObj)
  },

  // 获取Afterpay 快捷支付 地址信息
  getAfterPayExpressAddressInfo(dataObj: any) {
    return ajax.get('api', `/api/v1/payment/after-pay/express/checkout`, dataObj)
  },

  // 重新提交Afterpay 快捷支付
  afterpayExpressCaptureDeferred(dataObj: any) {
    return ajax.post('api', `/api/v1/payment/after-pay/express/capture-deferred`, dataObj)
  },

  // 获取Paypal 快捷支付 url
  getPaypalExpressUrl() {
    return ajax.get('api', `/api/v1/payment/paypal-express`, {})
  },

  // 获取Paypal 快捷支付 地址信息
  getPaypalExpressAddressInfo(dataObj: any) {
    return ajax.get('api', `/api/v1/payment/paypal-express/checkout`, dataObj)
  },

  // 重新提交Paypal 快捷支付
  paypalExpressCaptureDeferred(dataObj: any) {
    return ajax.post('api', `/api/v1/payment/paypal-express/submit`, dataObj)
  },

  // 验证Paypal 快捷支付
  paypalExpressCapture(dataObj: any) {
    return ajax.post('api', `/api/v1/payment/paypal-express/capture`, dataObj)
  },

  // 检查信用卡支付错误次数
  creditCardErrorCheck() {
    return ajax.get('api', `/api/v1/payment/cc-check`, {})
  }
}